import { Link } from 'react-router-dom';
import ConsultantCard from '@/components/feature/ConsultantCard';
import { teamMembers } from '@/mocks/team';

export default function MeetPeopleSection() {
  return (
    <section data-chapter-light className="chapter-fg py-20 md:py-28">
      <div className="wrap">
        <div className="mx-auto max-w-[1280px]">
          <div data-reveal-stagger className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10">
            <div className="lg:col-span-5">
              <p className="font-label text-[12px] md:text-[13px] tracking-[0.2em] chapter-muted">MEET OUR PEOPLE</p>
              <h2 className="mt-5 font-display font-normal text-[clamp(2rem,3.4vw,3rem)] leading-[1.1] tracking-[-0.015em]">
                Expertise is personal.
              </h2>
            </div>
            <div className="lg:col-span-6 lg:col-start-7 lg:pt-8 space-y-4 max-w-[560px] text-[16px] leading-[1.6] chapter-muted">
              <p>
                Our consultants bring years of experience in talent, HR, and organisational development — and a genuinely human approach to every partnership.
              </p>
              <p>
                You work directly with the people who understand your situation, not a rotating team.{' '}
                <Link to="/about" className="border-b border-current pb-0.5 whitespace-nowrap hover:text-accent-600 hover:border-accent-500 transition-colors duration-200 ease-ui focus-ring cursor-pointer">
                  Meet the full team
                </Link>
              </p>
            </div>
          </div>
          <div className="mt-12 md:mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {teamMembers.slice(0, 3).map((m) => (
              <ConsultantCard key={m.id} {...m} compact />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}